import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL, Form } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class AuthFormularioService {

  readonly baseUrl: string;
  
  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/formulario`;
  }

  public getForm(id: number): Observable<Form> {
    return this.http.get<Form>(`${this.baseUrl}/${id}`);
  }

  public findByIdAndVersion(id: number, version: number): Observable<Form> {
    return this.http.get<Form>(`${this.baseUrl}/${id}/${version}`);
  }
}
